const convertDegreesToCardinal = degrees => {
  let cardinal = ''
  if ((degrees <= 22.5) | (degrees > 337.5)) {
    cardinal = 'N'
  } else if ((degrees > 22.5) | (degrees >= 67.5)) {
    cardinal = 'NE'
  } else if ((degrees > 67.5) | (degrees >= 112.5)) {
    cardinal = 'E'
  } else if ((degrees > 112.5) | (degrees >= 157.5)) {
    cardinal = 'SE'
  } else if ((degrees > 157.5) | (degrees >= 202.5)) {
    cardinal = 'S'
  } else if ((degrees > 202.5) | (degrees >= 247.5)) {
    cardinal = 'SW'
  } else if ((degrees > 247.5) | (degrees >= 292.5)) {
    cardinal = 'W'
  } else if ((degrees > 292.5) | (degrees >= 337.5)) {
    cardinal = 'NW'
  }

  return cardinal
}

export default convertDegreesToCardinal



// WEBPACK FOOTER //
// ./src/utility/convertDegreesToCardinal.js